var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66309 5.33333L4.66309 3L7.99642 2L11.3298 3L13.3298 5.33333V10.6667L11.3298 13L7.99642 14L4.66309 13L2.66309 10.6667V5.33333Z",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66309 6.33333L5.99642 5L7.99642 4L9.99642 5L11.3298 6.33333V9.7778L9.99642 11.3333L7.99642 12L5.99642 11.3333L4.66309 9.7778V6.33333Z",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66309 13.0026L5.99642 11.3359",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 11.3359L11.3285 13.0026",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66309 3L5.99642 5",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 5L11.3285 3",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66309 5.33594L4.66309 6.33594",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99512 2V4",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66309 10.6641L4.66309 9.66406",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99512 14V12",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3271 10.6641L11.3271 9.66406",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3271 6.33594L13.3271 5.33594",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemStone);
export default __webpack_public_path__ + "static/media/GemStone.4a9704aaa392843d1ca14e3d1aa5ecd2.svg";
export { ForwardRef as ReactComponent };